// extracted by mini-css-extract-plugin
export default {"senses":"Senses_senses__481M+"};